export default {
  // Page
  采购订单记录: "採購訂單記錄",

  // FooterActions
  返回: "返回",

  // OrderInfoCard
  订单信息: "訂單信息",
  订单状态: "訂單狀態",
  采购单号: "採購單號",
  需求人: "需求人",
  需求部门: "需求部門",
  PO创建时间: "PO創建時間",
  工厂: "工廠",
  物料类别: "物料類別",
  二级物料类别: "二級物料類別",

  // DeliveryTable
  交货次数: "交貨次數",
  发货批次: "發貨批次",
  发货数量: "發貨數量",
  发货时间: "發貨時間",
  收货数量: "收貨數量",
  收货时间: "收貨時間",
  交货明细: "交貨明細",
  已发货数量: "已發貨數量",
  已收货数量: "已收貨數量",
  待发货数量: "待發貨數量",

  // PurchaseInfoCard
  采购信息: "採購信息",
  物料类型: "物料類別",
  生产性物料: "生產性物料",
  非生产性物料: "非生產性物料",
  供应商编号: "供應商編號",
  供应商中文名称: "供應商中文名稱",
  供应商英文名称: "供應商英文名稱",
  采购组: "採購組",
  币种: "幣種",
  汇率: "匯率",
  付款条约: "付款條約",
  国际贸易条款: "國際貿易條款",
  发货地址: "發貨地址",
  发货联系人: "發貨聯繫人",
  发货联系电话: "發貨聯繫電話",

  // ProductInfoCard
  采购产品信息: "採購產品信息",
  项目号: "項目號",
  物料编号: "物料編號",
  物料组: "物料組",
  会计科目: "會計科目",
  PO数量: "PO數量",
  单位: "單位",
  价格: "價格",
  价格单位: "價格單位",
  原币金额: "原幣金額",
  "本币金额（HKD）": "本幣金額（HKD）",
  "收货本币金额（HKD）": "收貨本幣金額（HKD）",
  "发票已付本币金额（HKD）": "發票已付本幣金額（HKD）",
  计划交货日期: "計劃交貨日期",
  库位: "庫位",
  收货地址: "收貨地址",
  收货联系人收货联系电话: "收貨聯繫人/收貨聯繫電話",

  // useOrderStatusOptions
  待发货: "待發貨",
  已发货: "已發貨",
  已部分收货: "已部分收貨",
  已收货: "已收貨",
  待收款: "待收款",
  已部分收款: "已部分收款",
  已收款: "已收款",

  // usePurchaseOrderRecordBehavior
  操作: "操作",
  查看: "查看",
  发货状态: "發貨狀態",
  付款状态: "付款狀態",
  订单编号: "訂單編號",
  PO编号: "PO編號",
  产品名称: "產品名稱",
  供应商编码: "供應商編碼",
  供应商: "供應商",
  金额: "金額",
  "收货联系人/收货联系电话": "收貨聯繫人/收貨聯繫電話",
  请输入物料编号或名称搜索: "請輸入物料編號或名稱搜索",
  请输入供应商编号或名称搜索: "請輸入供應商編號或名稱搜索",
};
